import userManager from "../authorization/authService";
import { clearPortalSession } from "../portal/portalAxios";
import { removeInstructorAccessToken } from "./instructorToken";

/**
 * Signs the person out of every context on this device (PD-0004, US-69): after a switch the
 * instructor and the portal sign-ins live side by side, so signing out of either side removes the
 * portal token and session, the instructor JWT and the OIDC user.
 */
export const signOutEverywhere = async (): Promise<void> => {
  clearPortalSession();
  removeInstructorAccessToken();
  await userManager.removeUser();
};
